module.exports = __webpack_public_path__ + "static/page-header-dont-1-246d80a3bd4306c1798d4f1ba0257fcb.png";